export const BOLD_TEXT = "You're previewing a student activity."
